module.exports = __webpack_public_path__ + "static/macht-f07c70e607d822825fa90dca4fbcfd6e.png";